// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/connector/v1/connector.proto (package mono.connector.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { CreateConnectorRequest, CreateConnectorResponse, DeleteConnectorRequest, DeleteConnectorResponse, GetConnectorRequest, GetConnectorResponse, ListConnectorsRequest, ListConnectorsResponse, SyncConnectorRequest, SyncConnectorResponse, TestConnectionRequest, TestConnectionResponse, UpdateConnectorRequest, UpdateConnectorResponse } from "./connector_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * ConnectorService provides external data source connector operations.
 *
 * @generated from service mono.connector.v1.ConnectorService
 */ export const ConnectorService = {
    typeName: "mono.connector.v1.ConnectorService",
    methods: {
        /**
     * CreateConnector creates a new data source connector.
     *
     * @generated from rpc mono.connector.v1.ConnectorService.CreateConnector
     */ createConnector: {
            name: "CreateConnector",
            I: CreateConnectorRequest,
            O: CreateConnectorResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListConnectors returns all connectors for a tenant.
     *
     * @generated from rpc mono.connector.v1.ConnectorService.ListConnectors
     */ listConnectors: {
            name: "ListConnectors",
            I: ListConnectorsRequest,
            O: ListConnectorsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetConnector returns a specific connector.
     *
     * @generated from rpc mono.connector.v1.ConnectorService.GetConnector
     */ getConnector: {
            name: "GetConnector",
            I: GetConnectorRequest,
            O: GetConnectorResponse,
            kind: MethodKind.Unary
        },
        /**
     * UpdateConnector updates an existing connector.
     *
     * @generated from rpc mono.connector.v1.ConnectorService.UpdateConnector
     */ updateConnector: {
            name: "UpdateConnector",
            I: UpdateConnectorRequest,
            O: UpdateConnectorResponse,
            kind: MethodKind.Unary
        },
        /**
     * DeleteConnector removes a connector.
     *
     * @generated from rpc mono.connector.v1.ConnectorService.DeleteConnector
     */ deleteConnector: {
            name: "DeleteConnector",
            I: DeleteConnectorRequest,
            O: DeleteConnectorResponse,
            kind: MethodKind.Unary
        },
        /**
     * SyncConnector triggers a sync operation.
     *
     * @generated from rpc mono.connector.v1.ConnectorService.SyncConnector
     */ syncConnector: {
            name: "SyncConnector",
            I: SyncConnectorRequest,
            O: SyncConnectorResponse,
            kind: MethodKind.Unary
        },
        /**
     * TestConnection tests connector credentials and connectivity.
     *
     * @generated from rpc mono.connector.v1.ConnectorService.TestConnection
     */ testConnection: {
            name: "TestConnection",
            I: TestConnectionRequest,
            O: TestConnectionResponse,
            kind: MethodKind.Unary
        }
    }
};
